/**
 * Set title of the page
 * @param {string=} title title
 */
const setTitle = title => {
    document.title = title ? `${title} - ${import.meta.env.VITE_SHORT_NAME}` : import.meta.env.VITE_SHORT_NAME
}

export default setTitle
